<template>
  <div class="monigerenzhengxinbaogao-layer">
    <!-- 标题区域 -->
    <div class="header-section">
      <h1 class="page-title">模拟个人征信报告</h1>
      <!-- <p class="page-subtitle">基于AI算法生成的个人信用评估报告</p> -->
      <p>
        <span>报告编号：{{ basicInfo.reportNo }}</span>
      </p>
      <p>
        <span>报告时间：{{ basicInfo.reportTime }}</span>
      </p>
    </div>

    <!-- 内容容器 -->
    <div class="content-container">
      <!-- 基本信息 -->
      <div class="info-section">
        <div class="section-title">
          <span class="title-icon"></span>
          <h3>基本信息</h3>
        </div>
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">姓名：</span>
            <span class="info-value">{{ basicInfo.name }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">身份证件类型：</span>
            <span class="info-value">{{ basicInfo.idCardType }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">身份证号：</span>
            <span class="info-value">{{ basicInfo.idCard }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">查询原因：</span>
            <span class="info-value">{{ basicInfo.queryReason }}</span>
          </div>
        </div>
      </div>

      <!-- 资产信息 -->
      <div class="credit-history-section">
        <div class="section-title">
          <span class="title-icon"></span>
          <h3>资产信息</h3>
        </div>
        <div class="history-grid2">
          <div class="history-grid-child">
            <div class="history-item item33">
              <div class="history-label">资产类型</div>
              <!-- <div class="history-value">{{ creditHistory.assetType1 }}</div> -->
               <div class="history-value">房产</div>
            </div>
            <div class="history-item item33">
              <div class="history-label">房产数量</div>
              <div class="history-value">{{ assetInfo.houseCount }}</div>
            </div>
            <div class="history-item item33">
              <div class="history-label">房产估值</div>
              <div class="history-value">{{ assetInfo.houseTotalValue }}</div>
            </div>
          </div>

          <div class="history-grid-child">
            <div class="history-item item33">
              <div class="history-label">资产类型</div>
              <!-- <div class="history-value">{{ creditHistory.assetType2 }}</div> -->
               <div class="history-value">活期存款</div>
            </div>
            <div class="history-item item33">
              <div class="history-label item2">资产估值</div>
              <div class="history-value">{{ assetInfo.depositTotalValue }}</div>
            </div>
            <div class="history-item item33">

            </div>
          </div>

          <div class="history-grid-child">
            <div class="history-item item33">
              <div class="history-label">资产类型</div>
              <!-- <div class="history-value">{{ creditHistory.assetType3 }}</div> -->
               <div class="history-value">车辆</div>
            </div>
            <div class="history-item item33">
              <div class="history-label item3">车辆数量</div>
              <div class="history-value">{{ assetInfo.vehicleCount }}</div>
            </div>
            <div class="history-item item33">
              <div class="history-label">车辆估值</div>
              <div class="history-value">{{ assetInfo.vehicleTotalValue }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 信贷信息 -->
      <div class="credit-history-section">
        <div class="section-title">
          <span class="title-icon"></span>
          <h3>信贷信息</h3>
        </div>
        <div class="history-grid">
          <div class="history-item">
            <div class="history-label">现有贷款</div>
            <div class="history-value">{{ creditInfo.existingLoanValue }}</div>
          </div>
          <div class="history-item">
            <div class="history-label">历史逾期次数</div>
            <div class="history-value">{{ creditInfo.historyOverdueCount }}</div>
          </div>
          <div class="history-item">
            <div class="history-label">失信人记录</div>
            <div class="history-value">
              {{ creditInfo.isHistoryOverdue ? '有' : '无' }}
            </div>
          </div>
        </div>
      </div>

      <!-- 查询信息 -->
      <div class="debt-section">
        <div class="section-title">
          <span class="title-icon"></span>
          <h3>查询信息</h3>
        </div>
        <div class="debt-grid">
          <div class="debt-item">
            <div class="debt-label">征信查询记录（6个月内）</div>
            <div class="debt-value">{{ queryRecord.recent6Months }}次</div>
          </div>
        </div>
      </div>

      <!-- 信用报告说明 -->
      <div class="suggestion-section">
        <div class="section-title">
          <span class="title-icon"></span>
          <h3>信用报告说明</h3>
        </div>
        <div class="suggestion-list">
          <div class="suggestion-item" v-for="(suggestion, index) in creditSuggestions" :key="index">
            <span class="suggestion-icon">💡</span>
            <span class="suggestion-text">{{ suggestion }}</span>
          </div>
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="action-section">
        <el-button class="prev-btn" @click="handlePrev">
          上一步
        </el-button>
        <!--此处跳转fastgpt搭建风险分析智能体-->
        <el-button type="primary" class="submit-btn" @click="handlerJumpToFastgpt">
          搭建风险分析智能体
        </el-button>
        <el-button type="primary" class="submit-btn" @click="handleSubmit">
          开始风险分析
        </el-button>
      </div>
    </div>

    <el-dialog title="请输入API秘钥开始风险分析" class="addDialog" :visible.sync="Visible" width="900px" :show-close="true"
               :close-on-press-escape="false" :close-on-click-modal="false">
      <div class="content-inner">
        <div class="l-inner">
          <div class="item">
            <div class="label-inner">请输入搭建的风险分析智能体API：</div>
            <el-input v-model="Form.api"></el-input>
          </div>
          <div class="item">
            <p>（工作流API秘钥通过dygpt-工作流-发布渠道获取）</p>
          </div>
        </div>
      </div>
      <div class="footer-inner" slot="footer">
        <!-- <el-button type="primary" size="small" @click="handleSave">保 存</el-button> -->
        <el-button type="primary" size="small" @click="handleUse">确 定</el-button>
        <el-button size="small" @click="Visible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apiUser from "@/api/user"
export default {
  name: '',
  components: {},
  props: {},
  data () {
    return {
      Visible: false,
      Form: {
        api: ''
      },
      // 资产信息
      assetInfo:{
        houseCount: '', //房产数量（0-3整数随机）
        houseTotalValue: '',//房产总价值（（10万-100万随机）*数量）
        vehicleCount: '', //车辆数量（0-3整数随机）
        vehicleTotalValue: '', //车辆总价值（（1万-50万随机）*数量）
        depositTotalValue: '', //存款总价值（0-1000万两位小数随机）
      },
      // 信贷信息
      creditInfo:{
        existingLoanValue: '', //现有贷款（0-1000万两位小数随机）
        historyOverdueCount: '', //历史逾期次数（0-5整数随机）
        isHistoryOverdue: '', //是否有历史逾期（随机）
      },
      // 查询信息
      queryInfo:{
        creditQueryCount: '', //征信查询记录（0-10整数随机）
      },

      // 基本信息
      basicInfo: {
        name: '',
        idCard: '',
        idCardType: '身份证',
        queryReason: '查询信用报告',
        reportNo: '',
        reportTime: ''
      },

      // 信用记录
      creditHistory: {
        loanBalance: 180000,
        overdueCount: 0,
        discreditCount: 0,
        assetType1: '房产',
        assetCount1: 1,
        assetValue1: 500000,
        assetType2: '活期存款',
        // assetCount2: 50000000,
        assetValue2: 50000000,
        assetType3: '车辆',
        assetCount3: 1,
        assetValue3: 300000,
      },
      // 查询记录
      queryRecord: {
        recent6Months: 5
      },

      // 信用报告说明
      creditSuggestions: [
        '本报告仅反映您截至报告生成日期的信用状况，不构成任何信贷建议。',
        '如对报告内容有异议，可向中国人民银行征信中心提出异议申请。',
        '信用报告查询次数过多可能会对您的信用产生负面影响。'
      ]
    }
  },
  computed: {
  },
  watch: {},
  created () {
      this.generateReportNo();
  },
  mounted () { 
     // 从sessionStorage获取用户之前填写的信息
    this.loadUserInfo();
    this.initData();
  },
  methods: {
    initData () {
      // 可以在这里加载已有数据
      apiUser.GetMockCreditReport().then((res) => {
        console.log("GetMockCreditReport>>>", res);
        let d = res.data;
        // 填充资产信息
        this.assetInfo.houseCount = d.assetInfo.houseCount;
        this.assetInfo.houseTotalValue = d.assetInfo.houseTotalValue;
        this.assetInfo.vehicleCount = d.assetInfo.vehicleCount;
        this.assetInfo.vehicleTotalValue = d.assetInfo.vehicleTotalValue;
        this.assetInfo.depositTotalValue = d.assetInfo.depositTotalValue;
        // 填充信贷信息
        this.creditInfo.existingLoanValue = d.creditInfo.existingLoanValue;
        this.creditInfo.historyOverdueCount = d.creditInfo.historyOverdueCount;
        this.creditInfo.isHistoryOverdue = d.creditInfo.isHistoryOverdue;
        // 填充查询信息
        this.queryInfo.creditQueryCount = d.queryInfo.creditQueryCount;

        sessionStorage.setItem('creditHistory', JSON.stringify(d));
      });
    },
    handleUse () {
      if (!this.Form.api) {
        this.$message.error('请输入API秘钥');
        return;
      }
      //也需要将表单里的数据填充
      sessionStorage.setItem('dkedyc_key', this.Form.api)
      this.$message.success('API秘钥已应用');
      this.Visible = false;
      // 触发下一步事件
      this.$emit('nextStep', 'fenxijieguo');
    },
    handlerJumpToFastgpt () {
       this.$router.push({ path: '/case/dygpt', query: { type: sessionStorage.getItem('casetype'), caseno: sessionStorage.getItem('caseno'), routename: 'xinyongfengxian', extend: '' } })
    },
    // 格式化金额
    formatMoney (amount) {
      return amount.toLocaleString('zh-CN');
    },

    // 获取使用率样式类
    getUsageClass (rate) {
      if (rate <= 30) return 'text-success';
      if (rate <= 70) return 'text-warning';
      return 'text-danger';
    },

    // 上一步
    handlePrev () {
      this.$emit('nextStep', 'daikuanxinxi');
    },

    // 生成报告
    handleSubmit () {
      this.Visible = true;
      // 触发下一步事件
      // this.$emit('nextStep', 'fenxijieguo');
    },

    // 生成随机报告编号
    generateReportNo () {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const randomNum = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
      
      this.basicInfo.reportNo = `CR${year}${month}${day}${randomNum}`;
      this.basicInfo.reportTime = `${year}-${month}-${day} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
    },
    
    // 从sessionStorage加载用户信息
    loadUserInfo () {
      try {
        const personInfo = sessionStorage.getItem('personInfo');
        const loanInfo = sessionStorage.getItem('loanInfo');
        
        if (personInfo) {
          const personData = JSON.parse(personInfo);
          this.basicInfo.name = personData.name || '张三';
          this.basicInfo.idCard = personData.idCard ? 
            personData.idCard.substring(0, 3) + '***********' + personData.idCard.substring(personData.idCard.length - 4) : 
            '310***********1234';
        }
        
        if (loanInfo) {
          const loanData = JSON.parse(loanInfo);
          // 可以根据贷款信息调整信用评估
          console.log('贷款信息:', loanData);
        }
      } catch (error) {
        console.error('加载用户信息失败:', error);
      }
    }
  },
}
</script>

<style scoped lang="less">
.monigerenzhengxinbaogao-layer {
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  overflow-y: auto;
}

// 标题区域
.header-section {
  text-align: center;
  margin-bottom: 30px;

  .page-title {
    font-size: 28px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 10px;
  }

  .page-subtitle {
    font-size: 16px;
    color: #b8c4e0;
    margin: 0;
  }
}

// 内容容器
.content-container {
  max-width: 1200px;
  margin: 0 auto;
}

// 通用区域样式
.info-section,
.credit-score-section,
.credit-history-section,
.debt-section,
.query-section,
.risk-section,
.suggestion-section {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 20px;
  border: 1px solid rgba(21, 73, 243, 0.2);
}

// 区域标题
.section-title {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(21, 73, 243, 0.2);

  .title-icon {
    width: 4px;
    height: 20px;
    background: linear-gradient(135deg, #1549F3 0%, #1890ff 100%);
    border-radius: 2px;
    margin-right: 12px;
  }

  h3 {
    font-size: 18px;
    color: #fff;
    margin: 0;
    font-weight: 600;
  }
}

// 基本信息网格
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 15px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  border: 1px solid rgba(21, 73, 243, 0.1);

  .info-label {
    font-size: 14px;
    color: #b8c4e0;
    margin-right: 10px;
    min-width: 80px;
  }

  .info-value {
    font-size: 14px;
    color: #fff;
    font-weight: 500;
  }
}

// 信用评分容器
.score-container {
  display: flex;
  align-items: center;
  gap: 40px;
}

// 信用分圆圈
.score-circle {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1549F3 0%, #1890ff 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;

  .score-value {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .score-label {
    font-size: 14px;
    opacity: 0.9;
  }
}

// 评分详情
.score-details {
  flex: 1;

  .score-level {
    margin-bottom: 15px;
  }

  .level-badge {
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    min-width: 80px;

    &.level-excellent {
      background: rgba(82, 196, 26, 0.2);
      color: #52c41a;
      border: 1px solid rgba(82, 196, 26, 0.3);
    }

    &.level-good {
      background: rgba(24, 144, 255, 0.2);
      color: #1890ff;
      border: 1px solid rgba(24, 144, 255, 0.3);
    }

    &.level-fair {
      background: rgba(250, 173, 20, 0.2);
      color: #faad14;
      border: 1px solid rgba(250, 173, 20, 0.3);
    }

    &.level-poor {
      background: rgba(245, 34, 45, 0.2);
      color: #f5222d;
      border: 1px solid rgba(245, 34, 45, 0.3);
    }
  }

  .score-desc {
    font-size: 16px;
    color: #b8c4e0;
    margin-bottom: 10px;
  }

  .score-rank {
    font-size: 14px;
    color: #fff;
  }
}

.history-grid2 {
  display: flex;
  // grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  // gap: 20px;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
}

.history-grid-child {
  display: flex;
  justify-content: space-around;
  width: 100%;
}

.item33 {
  margin-top: 20px;
  width: 33%;
}

// 信用记录网格
.history-grid,
.debt-grid,
.query-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.history-item,
.debt-item,
.query-item {
  text-align: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  border: 1px solid rgba(21, 73, 243, 0.1);
  transition: all 0.3s ease;

  &:hover {
    background: rgba(21, 73, 243, 0.1);
    transform: translateY(-2px);
  }

  .history-label,
  .debt-label,
  .query-label {
    font-size: 14px;
    color: #b8c4e0;
    margin-bottom: 10px;
  }

  .history-value,
  .debt-value,
  .query-value {
    font-size: 18px;
    color: #fff;
    font-weight: 600;

    &.text-success {
      color: #52c41a;
    }

    &.text-warning {
      color: #faad14;
    }

    &.text-danger {
      color: #f5222d;
    }
  }
}

// 风险提示列表
.risk-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.risk-item {
  display: flex;
  align-items: flex-start;
  padding: 15px;
  background: rgba(245, 34, 45, 0.1);
  border-radius: 8px;
  border: 1px solid rgba(245, 34, 45, 0.2);

  .risk-icon {
    margin-right: 10px;
    font-size: 16px;
  }

  .risk-text {
    font-size: 14px;
    color: #ffccc7;
    line-height: 1.5;
  }
}

// 信用建议列表
.suggestion-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.suggestion-item {
  display: flex;
  align-items: flex-start;
  padding: 15px;
  background: rgba(24, 144, 255, 0.1);
  border-radius: 8px;
  border: 1px solid rgba(24, 144, 255, 0.2);

  .suggestion-icon {
    margin-right: 10px;
    font-size: 16px;
  }

  .suggestion-text {
    font-size: 14px;
    color: #b8c4e0;
    line-height: 1.5;
  }
}

// 操作区域
.action-section {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid rgba(21, 73, 243, 0.2);

  .submit-btn {
    padding: 12px 40px;
    font-size: 16px;
    font-weight: bold;
    background: linear-gradient(135deg, #1549F3 0%, #1890ff 100%);
    border: none;
    border-radius: 8px;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(21, 73, 243, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .prev-btn {
    padding: 12px 40px;
    font-size: 16px;
    font-weight: bold;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(21, 73, 243, 0.3);
    border-radius: 8px;
    color: #b8c4e0;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(21, 73, 243, 0.2);
      color: #fff;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .monigerenzhengxinbaogao-layer {
    padding: 10px;
  }

  .header-section {
    margin-bottom: 20px;

    .page-title {
      font-size: 24px;
    }

    .page-subtitle {
      font-size: 14px;
    }
  }

  .info-section,
  .credit-score-section,
  .credit-history-section,
  .debt-section,
  .query-section,
  .risk-section,
  .suggestion-section {
    padding: 20px;
    margin-bottom: 15px;
  }

  .score-container {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }

  .info-grid,
  .history-grid,
  .debt-grid,
  .query-stats {
    grid-template-columns: 1fr;
  }

  .action-section {
    flex-direction: column;
    align-items: center;

    .submit-btn,
    .prev-btn {
      width: 200px;
    }
  }
}


.addDialog {
  backdrop-filter: blur(5px);

  /deep/ .el-dialog {
    border: 1px solid rgba(29, 156, 181, 0.3);
    padding: 0 20px;
    border-radius: 10px;
    background-color: #fff;

    .el-dialog__headerbtn {
      font-size: 20px !important;
    }
  }

  .content-inner {
    height: 500px;

    .label-inner {
      color: #fff;
      margin-bottom: 12px;
      font-size: 15px;
      user-select: none;
    }

    .l-inner {
      // float: left;
      // width: 53%;
      // margin-right: 30px;
      width: 100%;
    }

    .item {
      margin-bottom: 30px;

      /deep/ textarea {
        resize: none;
      }

      .play-icon {
        margin-left: 15px;
        cursor: pointer;
        color: #0f99cb;

        &::before {
          font-size: 20px;
          margin-right: 2px;
          vertical-align: middle;
        }

        &:hover {
          color: #1e589f;
        }
      }
    }

  }

  .footer-inner {
    text-align: center;

    .el-button {
      min-width: 120px;
      letter-spacing: 2px;
    }
  }
}
</style>
